import React from 'react';

import { Divider, Text } from '@thefarmersfront/kitchen';

import {
  ProductDetailsModalProductInfoSectionDefault,
  ProductDetailsModalProductInfoSectionMeasurement,
  ProductDetailsModalProductInfoSectionPolicy,
} from '.';

import styles from './ProductDetailsModalProductInfoSection.module.scss';

const ProductDetailsModalProductInfoSection = ({ hasTempData }: { hasTempData: boolean }) => {
  return (
    <div className={styles['product-info-section']}>
      <Text className={styles['section-title']} size="xxlarge" weight="bold">
        상품 정보
      </Text>

      <ProductDetailsModalProductInfoSectionDefault hasTempData={hasTempData} />

      <div className={styles['divider-wrapper']}>
        <Divider color="gray100" />
      </div>

      <ProductDetailsModalProductInfoSectionPolicy hasTempData={hasTempData} />

      <div className={styles['divider-wrapper']}>
        <Divider color="gray100" />
      </div>

      <ProductDetailsModalProductInfoSectionMeasurement hasTempData={hasTempData} />
    </div>
  );
};

export default ProductDetailsModalProductInfoSection;
